export default function (state, getters) {
    return getters.loading_dictionary || state.load.data;
}